var _path, _path2, _line;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectionsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,0a5,5,0,0,0-5,5,4.77,4.77,0,0,0,.06.76,14.37,14.37,0,0,1,2-.48A1.27,1.27,0,0,1,20,5a3,3,0,0,1,6,0,1.27,1.27,0,0,1,0,.28,14.37,14.37,0,0,1,2,.48A4.77,4.77,0,0,0,28,5,5,5,0,0,0,23,0Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23,7a15.13,15.13,0,0,0-11.25,5.15A18.55,18.55,0,0,0,7.09,22.9c3.26.06,10.32.1,17.85.1,7,0,11.63,0,14-.08a18.55,18.55,0,0,0-4.66-10.77A15.13,15.13,0,0,0,23,7m0-2c9.94,0,18,8.87,18,19.82,0,.13-7.74.18-16.06.18C15.35,25,5,24.93,5,24.82,5,13.87,13.06,5,23,5Z",
    fill: "#fff"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1,
    y1: 24,
    x2: 45,
    y2: 24,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectionsIcon);
export default __webpack_public_path__ + "static/media/selections-icon.421a3f1ac11840df190dd8f9652de217.svg";
export { ForwardRef as ReactComponent };